import { computed, Directive, input } from '@angular/core';
import { resolveColorContext, type ContextFamily } from '@quipex/shared/utils';

export type DropAppearance =
    | { readonly state: 'idle' | 'invalid' | 'busy' | 'disabled' }
    | { readonly state: 'valid'; readonly context?: ContextFamily };

/** Presentation only: the owning interaction decides eligibility and state. */
@Directive({
    selector: '[qpxDropSurface]',
    host: {
        '[attr.data-qpx-drop-state]': 'appearance()?.state ?? null',
        '[style.--qpx-drop-context-surface]': 'surface()',
        '[style.--qpx-drop-context-foreground]': 'foreground()',
        '[style.--qpx-drop-context-decorative]': 'decorative()',
    },
})
export class QpxDropSurface {
    public readonly appearance = input.required<DropAppearance | null>({
        alias: 'qpxDropSurface',
    });

    private readonly colors = computed(() => {
        const appearance = this.appearance();
        if (appearance?.state === 'invalid') {
            return resolveColorContext('destructive', 'muted');
        }
        return appearance?.state === 'valid'
            ? resolveColorContext(appearance.context ?? 'primary', 'muted')
            : null;
    });
    protected readonly surface = computed(() => {
        const colors = this.colors();
        return colors ? `var(${colors.surface.variable})` : null;
    });
    protected readonly foreground = computed(() => {
        const colors = this.colors();
        return colors ? `var(${colors.foreground.variable})` : null;
    });
    protected readonly decorative = computed(() => {
        const colors = this.colors();
        return colors ? `var(${colors.decorative.variable})` : null;
    });
}
